import { render, staticRenderFns } from "./AddRow.vue?vue&type=template&id=36c4090d&"
import script from "./AddRow.vue?vue&type=script&lang=js&"
export * from "./AddRow.vue?vue&type=script&lang=js&"
import style0 from "./AddRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports